import type { DashboardCatalogGroup, DashboardGroupGrant } from '../../../svetofor-dashboard/api'

export type DashboardAccessMode = 'none' | 'all' | 'selected'

export const getSelectedIndicatorIds = (group: DashboardCatalogGroup, grants: DashboardGroupGrant[]) => {
  const grant = grants.find(item => item.groupId === group.id)
  return group.indicators.filter(item => grant?.all || grant?.indicatorIds.includes(item.id)).map(item => item.id)
}

export const changeGroupAccess = (grants: DashboardGroupGrant[], group: DashboardCatalogGroup, mode: DashboardAccessMode): DashboardGroupGrant[] => {
  const others = grants.filter(item => item.groupId !== group.id)
  if (mode === 'none') return others
  if (mode === 'all') return [...others, { groupId: group.id, all: true, indicatorIds: [] }]
  const indicatorIds = getSelectedIndicatorIds(group, grants)
  return indicatorIds.length ? [...others, { groupId: group.id, all: false, indicatorIds }] : others
}

export const changeIndicatorAccess = (grants: DashboardGroupGrant[], group: DashboardCatalogGroup, indicatorId: number, checked: boolean): DashboardGroupGrant[] => {
  if (!group.indicators.some(item => item.id === indicatorId)) return grants
  const ids = new Set(getSelectedIndicatorIds(group, grants))
  if (checked) ids.add(indicatorId)
  else ids.delete(indicatorId)
  const others = grants.filter(item => item.groupId !== group.id)
  return ids.size ? [...others, { groupId: group.id, all: false, indicatorIds: [...ids] }] : others
}

export const dashboardAccessKey = (grants: DashboardGroupGrant[]) => JSON.stringify(grants.map(item => ({
  groupId: item.groupId,
  all: item.all,
  indicatorIds: item.all ? [] : [...item.indicatorIds].sort((a, b) => a - b),
})).sort((a, b) => a.groupId - b.groupId))

export const russianCount = (count: number, forms: [string, string, string]) => {
  const lastTwo = count % 100
  const last = count % 10
  const word = lastTwo >= 11 && lastTwo <= 14 ? forms[2] : last === 1 ? forms[0] : last >= 2 && last <= 4 ? forms[1] : forms[2]
  return `${count} ${word}`
}
